import styled from 'styled-components';
import bg from '~/assets/bg-section-02.png';
import vetor from '~/assets/ilustra-01.png';
import alert from '~/assets/icon-alert.png';

export const Container = styled.section`
  position: relative;
  background-color: rgba(168, 223, 244, 0.77);
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  margin-top: 200px;
  &.flex-wrap {
    flex-wrap: wrap;
  }
  &:before,
  &:after {
    content: '';
    display: block;
    width: 100%;
    position: absolute;
    left: 0;
    background-repeat: no-repeat;
    background-image: url(${bg});
  }
  &:before {
    height: 187px;
    background-position: top center;
    top: 0;
    margin-top: -187px;
  }
  &:after {
    height: 74px;
    background-position: bottom center;
    bottom: 0;
    margin-bottom: -74px;
  }
  .ArrowDown {
    margin-bottom: -80px;   
  }
`;

export const TextContent = styled.div` 
  flex: 0 0 100%;
  max-width: 100%;
  font-size: 27px;
  font-weight: 400;
  color: #545353;
  padding-left: 116px;
  padding-right: 116px;
  b {
    font-weight: 900;
  }
  p {
    margin-bottom: 30px;
    line-height: 40px;
  }
  .highlight {
    font-size: 31px;
    b {
      span {
        color: #1c56a4;
        text-decoration: underline;
      }
    }
    &.infos {
      border: solid 1px #6da6bb;
      background: #c5e9f7;
      border-radius: 10px;
      padding: 15px 20px;
      /* overflow: hidden; */
      text-align: center;
      margin: 30px 0;
      b {
        text-align: center;
        display: block;
        color: #27357c;
        text-shadow: 2px 2px 0px rgb(148, 182, 230);
        &.red {
          color: #831d13;
          font-size: 45px;
        }
      }
    }
  }
  @media (max-width: 1480px) {
    padding-left: 15px;
    font-size: calc(100vw / 75);
  }
  @media (max-width: 1300px) {
    padding-right: 15px;
    flex: 0 0 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    /* flex-wrap: wrap; */

    /* font-size: calc(100vw / 75); */
    p {
      flex: 1 1 100%;
      max-width: 100%;
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3) {
        flex: 1 1 100%;
        max-width: 100%;
      }
    }
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      display: block;
      width: 40%;
      padding-bottom: 45%;
      /*background-image: url(${vetor});*/
      background-repeat: no-repeat;
      background-position: bottom center;
      background-size: contain;
    }
  }
  @media (max-width: 1024px) {
    font-size: 16px;
    &:after {
      width: 50%;
      padding-bottom: 55%;
    }
  }
  @media (max-width: 850px) {
    p {
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4) {
        flex: 1 1 100%;
        max-width: 100%;
      }
    }
  }
  @media (max-width: 750px) {
    p {
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        flex: 1 1 100%;
        max-width: 100%;
      }
    }
  }
  @media (max-width: 590px) {
    p {
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5),
      &:nth-child(6) {
        flex: 1 1 100%;
        max-width: 100%;
      }
    }
  }
  @media (max-width: 470px) {
    p {
      flex: 1 1 100%;
      max-width: 100%;
    }
    &:after {
      display: none;
    }
  }
`;

export const Vector = styled.div`
  flex: 0 0 50%;
  max-width: 50%;
  /* height: 100%; */
  /*background-image: url(${vetor});*/
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: contain;
  transform: translateY(85px);
  z-index: 3;
  @media (max-width: 1300px) {
    display: none;
    /* background-position: center; */
    /* transform: translateY(0); */
  }
`;

export const Title = styled.h3`
  width: 100%;
  max-width: 1700px;
  padding: 0 10px;
  color: #27357c;
  font-size: 55px;
  font-weight: 900;
  text-shadow: 2px 2px 0 #a8dff4;
  text-align: center;
  margin: 0 auto;
  span {
    display: block;
    text-align: center;
    color: #831d13;
  }
  @media (max-width: 992px) {
    padding: 0 15px;
    font-size: calc(100vw / 15);
  }
  @media (max-width: 540px) {
    font-size: calc(100vw / 18);
  }
  @media (max-width: 500px) {
    font-size: 25px;
  }
  /* @media (min-width: 992px) and (max-width: 5000px) {
    margin-top: 250px;
  } */
`;

export const AlertBox = styled.div`
  flex: 0 0 70%;
  max-width: 70%;
  margin: 0 auto 50px;
  padding: 15px;
  padding-left: 45px;
  color: #545353;
  position: relative;
  &:before {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    display: block;
    width: 60px;
    height: 60px;
    background-position: center 10px;
    background-repeat: no-repeat;
    background-size: 70%;
    background-color: #fff;
    background-image: url(${alert});
    margin: 5px 0 0 10px;
    border-radius: 50%;
    box-shadow: 2px 2px 7px rgba(0, 0, 0, 0.3);
  }
  & > div {
    background: #fff;
    border-radius: 5px;
    padding: 25px 15px;
    padding-left: 40px;
    box-shadow: 2px 2px 7px rgba(0, 0, 0, 0.13);
    p {
      line-height: 2;
      font-size: 15px;
    }
  }
`;
